import { render, staticRenderFns } from "./Launchpad.vue?vue&type=template&id=63792752&"
import script from "./Launchpad.vue?vue&type=script&lang=js&"
export * from "./Launchpad.vue?vue&type=script&lang=js&"
import style0 from "./Launchpad.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports